import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-section05',
  templateUrl: './section05.component.html',
  styleUrls: ['./section05.component.scss']
})

export class Section05Component implements OnInit {
  @Input() data;

  constructor() {
  }

  ngOnInit() {
  }

}
